import { EmailSettingsLayout } from './components';
import { AccountVerificationStatusPage } from './account-verification-status-page';

export default function AccountVerificationStatusPageWrapper() {
  return (
    <EmailSettingsLayout title="Account Verification Status">
      <AccountVerificationStatusPage />
    </EmailSettingsLayout>
  );
}
